<template>
    <div>
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            签注进度查询-->
<!--        </div>-->
        <van-field label="证件类型:" :value="value" placeholder="往来港澳通行证" readonly is-link @click="showPicker = true"/>
        <van-field label="证件号码:" :value="value2" placeholder="例如:C00000000" readonly is-link
                   @click="showPicker2 = true"/>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="query">查询</van-button>
        </div>

    </div>
</template>

<script>
    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {taskApiMap} from "@/api/task";
    import { idCardRegex } from '@/utils/regex'

    export default {
        name: "CertificatesQuery",
        components: {
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                handlingId: '', // 身份证号
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                value: '',
                showPicker: false,
                columns: ['杭州', '宁波', '温州', '嘉兴', '湖州']
            }
        },
        methods: {
            onConfirm(value) {
                this.value = value;
                this.showPicker = false;
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

            /**
             * 点击查询
             */
            async query() {
                if (!this.handlingId) {
                    Toast('请输入身份证号')
                } else if(!idCardRegex(this.handlingId)) {
                    Toast('请输入正确的身份证号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        const res = await this.$httpUtils.getCommonUtils(`${taskApiMap.tskNum}/${this.handlingId}`, data)
                        if (res.data.data) {
                            Toast.clear()
                            this.$router.push({
                                path: '/myHandlingScheduleQueryDetails',
                                query: {data: JSON.stringify(res.data.data)}
                            })
                        } else {
                            Toast.fail('查询失败')
                            this.$refs.childFunction.interactionVerificationCode()
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>
    .title {
        padding: 20px 10px 10px 10px;
        height: 80px;
        font-size: 32px;
        color: #fff;
        background-color: #1989fa;
        position: relative;
        text-align: center;
    }
    .return img {
        font-size: 40px;
        width: 18px;
        height: 29px;
        position: fixed;
        left: 0.4rem;
        top: 0.35rem;
    }


</style>
